export default __webpack_public_path__ + "27b1586d43d81d578ee85c9ade36057a.png";